import {  put, takeEvery} from 'redux-saga/effects'
import {loadingStart, loadingStop} from '../action'
import {push} from 'react-router-redux'
import {getFirebase} from 'react-redux-firebase'


function* addProfile(payload) {
    yield put(loadingStart("เพิ่มรายละเอียด..."))
    try{
        getFirebase().updateProfile({
            name: payload.name,
            level: payload.level,
            school: payload.school,
            type: payload.userType,
            profileCompleted: true,
        })
    
    yield put(loadingStop())
    yield put(push('/'))
    } catch(err) {
        //console.log('-----SAGA ERROR-----', err)
    }
}
export default function* ProfileSaga() {
    yield takeEvery('@@profile/ADD', addProfile)
}



// WEBPACK FOOTER //
// ./src/profile/saga.js